import { ReactNode } from 'react'
import {
  Tooltip as UITooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@alphabait/ui'

type TooltipProps = {
  child: ReactNode
  text: string
}

export default function Tooltip({ child, text }: TooltipProps) {
  return (
    <TooltipProvider delayDuration={1}>
      <UITooltip>
        <TooltipTrigger asChild>{child}</TooltipTrigger>
        <TooltipContent>
          <p className="bg-black text-white px-2 py-1 text-sm rounded-full">
            {text}
          </p>
        </TooltipContent>
      </UITooltip>
    </TooltipProvider>
  )
}
